import { RaceCardData } from "../../data/data";
import NotFound from "../../assets/notfount.png";
import NotFoundArabic from "../../assets/notresultarabic.png";
import Defaultimg from "../../assets/Frame.png";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useState } from "react";
import Cookies from "js-cookie";
import Image from "../Reuseable/Image";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toTitleCase } from "../../service/stringUtils";

const Summary = () => {
  const [distance, setDistance] = useState([]);
  const [racecourse, setRacecourse] = useState([]);
  const [classtype, setClasstype] = useState([]);
  const [trainer, setTrainer] = useState([]);
  const [pedigree, setPedigree] = useState([]);
  const [overall, setOverall] = useState([]);
  const [firstFiveHorses, setFirstFiveHorses] = useState([]);
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const { data: summary, status } = useSelector((state) => state.summary);
  const { data: singlerace } = useSelector((state) => state.singlerace);

  useEffect(() => {
    setDistance(summary?.Distance);
    setRacecourse(summary?.RaceCourse);
    setClasstype(summary?.ClassType);
    setTrainer(summary?.Time);
    setPedigree(summary?.Pedigree);
    setOverall(summary?.OverAll);
    setFirstFiveHorses(summary?.FirstFiveHorses);
  }, [
    summary?.ClassType,
    summary?.Distance,
    summary?.OverAll,
    summary?.Pedigree,
    summary?.RaceCourse,
    summary?.Time,
    summary?.FirstFiveHorses,
  ]);

  const extendedDistance =
    distance?.length == 0
      ? firstFiveHorses
      : distance;
  const extendedracecourse =
    racecourse?.length == 0
      ? firstFiveHorses
      : racecourse;
  const extendedclasstype =
    classtype?.length == 0
      ? firstFiveHorses
      : classtype;
  const extendedtrainer =
    trainer?.length == 0
      ? firstFiveHorses
      : trainer;
  const extendedpedigree =
    pedigree?.length == 0
      ? firstFiveHorses
      : pedigree;
  const extendedoverall =
    overall?.length == 0
      ? firstFiveHorses
      : overall;

  const renderCategoryBox = (title, dataList) => {
    return (
      <div className="new-summary-col col-sm-4">
        <p className="new-summary-title">{window.textTransform(title)}</p>
        {!dataList || dataList.length === 0 ? (
          <SkeletonTheme baseColor="#1e293b" highlightColor="#334155">
            <p><Skeleton count={3} height={35} style={{ marginBottom: 8, borderRadius: 6 }} /></p>
          </SkeletonTheme>
        ) : (
          dataList.map((item, i) => {
            // Determine Horse Number
            let horseNo = "-";
            if (item.HorseModelIdData1 && item.HorseModelIdData1.length > 0) {
              horseNo = item.HorseNo || "-";
            } else if (item.HorseIDData && item.HorseIDData.HorseModelIdData1 && item.HorseIDData.HorseModelIdData1[0]) {
              horseNo = item.HorseIDData.HorseModelIdData1[0].HorseNo || "-";
            } else if (item.HorseNo) {
              horseNo = item.HorseNo;
            }

            // Find this horse in the main singlerace data to get the correct silk and name
            const horseInCard = singlerace?.racehorses?.RacehorsesData?.find(h =>
              h.HorseNo == horseNo ||
              h.HorseModelIdData1?._id === (item.HorseModelIdData1?.[0]?._id || item.HorseModelIdData1?._id || item.HorseIDData?._id)
            );

            // Determine Name - preserve full spaces matching race card
            const rawNameEn = horseInCard?.HorseModelIdData1?.NameEn ||
              item.HorseIDData?.NameEn ||
              item.HorseModelIdData1?.[0]?.NameEn ||
              item.HorseModelIdData1?.NameEn || "";

            const rawNameAr = horseInCard?.HorseModelIdData1?.NameAr ||
              item.HorseIDData?.NameAr ||
              item.HorseModelIdData1?.[0]?.NameAr ||
              item.HorseModelIdData1?.NameAr || "";

            let horseName = "";
            if (cookiedata === "en") {
              horseName = toTitleCase(rawNameEn);
            } else {
              horseName = rawNameAr || "-";
            }

            return (
              <div key={item.id || item._id || i} className="new-summary-pill">
                <div className="new-summary-number">{horseNo}</div>
                <div className="new-summary-icon-wrap">
                  <img
                    src={horseInCard?.CapColorData1?.OwnerSilkColor || Defaultimg}
                    alt="Silk"
                    className={horseInCard?.CapColorData1?.OwnerSilkColor ? "new-summary-silk-img" : "summary-noplaceher"}
                  />
                </div>
                <div className="new-summary-name" title={horseName}>{horseName}</div>
              </div>
            );
          })
        )}
      </div>
    );
  };

  return (
    <div className="new-summary-wrapper">
      {status == "loading" ? (
        <div className="text-center py-5">
          <Lottie animationData={Animate} className="Lottie compLottie" style={{ width: 150, margin: 'auto' }} />
        </div>
      ) : (
        <div className="row">
          {renderCategoryBox(t("Distance"), extendedDistance)}
          {renderCategoryBox(t("Class"), extendedclasstype)}
          {renderCategoryBox(t("Time"), extendedtrainer)}
          {renderCategoryBox(t("Pedigree"), extendedpedigree)}
          {renderCategoryBox(t("Race Course"), extendedracecourse)}
          {renderCategoryBox(t("Overall"), extendedoverall)}
        </div>
      )}
    </div>
  );
};
export default Summary;
